// extracted by mini-css-extract-plugin
export var btn = "table-module--btn--9ASum";
export var contact = "table-module--contact--nn+AC";
export var table = "table-module--table--X1WfT";